
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 1a1 1 0 011 1v2a1 1 0 11-2 0V2a1 1 0 011-1zm0 8a3 3 0 100 6 3 3 0 000-6zm-5 3a5 5 0 1110 0 5 5 0 01-10 0zm12.713-6.3A1 1 0 0018.3 4.288l-1.285 1.285a1 1 0 001.414 1.414l1.285-1.285zM4.287 4.288a1 1 0 011.415 0l1.285 1.285a1 1 0 11-1.414 1.414L4.287 5.701a1 1 0 010-1.414zm14.142 12.727a1 1 0 10-1.414 1.414l1.285 1.286a1 1 0 101.415-1.415l-1.286-1.285zm-11.442 0a1 1 0 010 1.414l-1.285 1.286a1 1 0 11-1.415-1.415l1.286-1.285a1 1 0 011.414 0zM22 13a1 1 0 100-2h-2a1 1 0 100 2h2zM5 12a1 1 0 01-1 1H2a1 1 0 110-2h2a1 1 0 011 1zm8 8a1 1 0 10-2 0v2a1 1 0 102 0v-2z","fill":"currentColor"}})])
          )
        }
      }
    